import React from "react";

export default function LCAResults({ outputContract }) {
  if (!outputContract) {
    return (
      <section style={{ marginTop: 20 }}>
        <h3>Detailed LCA Breakdown</h3>
        <p>No LCA results loaded.</p>
      </section>
    );
  }

  const breakdown = outputContract?.breakdown || {};

  const interpretation = outputContract?.interpretation || {};

  const totalRecords = interpretation.total_records ?? 0;
  const governedCount = interpretation.governed_count ?? 0;
  const excludedCount = interpretation.excluded_count ?? 0;
  const governedRatio = interpretation.governed_ratio ?? 0;

  const topExclusionReason =
    interpretation.top_exclusion_reason || "N/A";

  const topExclusionMaterialKeys =
    interpretation.top_exclusion_material_keys || [];

  const exclusionBreakdown =
    interpretation.exclusion_reason_breakdown || {};

  const byStage = Array.isArray(breakdown.by_stage)
    ? breakdown.by_stage.filter((row) => Number(row.kg_co2e || 0) > 0)
    : [];

  const byStageGroup = Array.isArray(breakdown.by_stage_group)
    ? breakdown.by_stage_group.filter((row) => Number(row.kg_co2e || 0) > 0)
    : [];

  const byMaterialCategory = Array.isArray(breakdown.by_material_category)
    ? breakdown.by_material_category
        .filter((row) => Number(row.kg_co2e || 0) > 0)
        .sort((a, b) => Number(b.kg_co2e || 0) - Number(a.kg_co2e || 0))
    : [];


  return (
    <section
      style={{
        marginTop: 6,
        padding: 20,
        border: "1px solid #d9e2f1",
        borderRadius: 18,
        background: "#ffffff",
        boxShadow: "0 12px 28px rgba(0,0,0,0.06)",
      }}
    >

      {byMaterialCategory.length > 0 && (
        <div style={{ marginTop: 20 }}>
          <h4 style={{ marginBottom: 16, fontSize: "20px", fontWeight: 900 }}>
            Main Contributors
          </h4>

          {byMaterialCategory.slice(0, 5).map((row, idx) => {
            const isDominant = idx === 0;
            const isTopThree = idx < 3;

            return (
              <div key={idx} style={{ marginBottom: 10 }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "140px 1fr 180px",
                    gap: 12,
                    alignItems: "center",
                    marginBottom: 6,
                  }}
                >
                  <strong
                    style={{
                      textTransform: "capitalize",
                      fontSize: isDominant ? "14px" : "13px",
                      color: isTopThree ? "#14223b" : "#94a3b8",
                      fontWeight: isDominant ? 800 : isTopThree ? 700 : 500,
                    }}
                  >
                    {row.category}
                  </strong>

                  <div
                    style={{
                      height: 12,
                      background: "#e0e6f0",
                      borderRadius: 999,
                      overflow: "hidden",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        width: `${row.percentage_of_total}%`,
                        height: "100%",
                        background: isDominant ? "#020617" : isTopThree ? "#3b82f6" : "#cbd5e1",
                        transition: "width 0.4s ease",
                      }}
                    />
                  </div>

                  <span
                    style={{
                      textAlign: "right",
                      whiteSpace: "nowrap",
                      fontSize: isDominant ? "13px" : "12px",
                      color: isTopThree ? "#30425c" : "#94a3b8",
                      fontWeight: isDominant ? 700 : isTopThree ? 600 : 400,
                      minWidth: "180px",
                      display: "inline-block",
                    }}
                  >
                    {row.kg_co2e.toFixed(2)} kgCO₂e ({row.percentage_of_total.toFixed(2)}%)
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}